import httpService from '../../http'
import api from '../../api'
import helpers from '../../helpers'
const apiModule = api.orders
const errorsStr = helpers.error.errors
const mapper = helpers.mapper

function getModel () {
  return {
    id: {
      data: 'id',
      title: 'ID',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    createdAt: {
      data: 'createdAt',
      title: 'Дата',
      value: null,
      type: 'datetime',
      order: 'desc',
      showOrder: true
    },
    updatedAt: {
      data: 'updatedAt',
      title: 'Дата последнего обновления',
      value: null,
      type: 'datetime',
      order: null,
      showOrder: true
    },
    bonus: {
      data: 'bonus',
      title: 'Бонусы',
      value: null,
      type: 'bonus',
      order: null,
      showOrder: true
    },
    command: {
      data: 'command',
      title: 'Команда',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    countMinutes: {
      data: 'countMinutes',
      title: 'Время массажа',
      value: null,
      type: null
    },
    dealerIdMysql: {
      data: 'dealerIdMysql',
      title: 'Диллер',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    info: {
      data: 'info',
      title: 'Тип действия',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    kontrollerIdMysql: {
      data: 'kontrollerIdMysql',
      title: 'ID кресла',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    payType: {
      data: 'payType',
      title: 'Тип оплаты',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    pointId: {
      data: 'pointId',
      title: 'ID точки',
      value: null,
      type: null
    },
    pointIdMySql: {
      data: 'pointIdMySql',
      title: 'ID точки (mysql)',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    pointName: {
      data: 'pointName',
      title: 'Точка',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    price: {
      data: 'price',
      title: 'Стоимость',
      value: null,
      type: 'price',
      order: null,
      showOrder: true
    },
    sberOrderId: {
      data: 'sberOrderId',
      title: 'ID сбербанка',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    status: {
      data: 'status',
      title: 'Статус',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    urlOrderDoc: {
      data: 'urlOrderDoc',
      title: 'Чек',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    user: {
      data: 'user',
      title: 'Пользователь',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    userId: {
      data: 'userId',
      title: 'ID пользователя',
      value: null,
      type: null,
      order: null,
      showOrder: true
    }
  }
};

function role () { return localStorage.getItem('role') }

const state = {
  model: getModel(),
  id: null,
  userId: null,
  show: 'all',
  one: getModel(),
  all: [],
  errMain: null,
  errors: {},
  tabs: {
    admin: {
      order: {
        data: 'order',
        title: 'Информация',
        active: true
      },
      user: {
        data: 'user',
        title: 'Пользователь',
        active: false
      }
    },
    dealer: {
      order: {
        data: 'order',
        title: 'Информация',
        active: true
      },
      user: {
        data: 'user',
        title: 'Пользователь',
        active: false
      }
    }
  }
}
const getters = {
  getModel (state) { return state.model },
  getId (state) { return state.id },
  getUserId (state) { return state.userId },
  getShow (state) { return state.show },
  getOne (state) { return state.one },
  getAll (state) { return state.all },
  getErrors (state) { return state.errors },
  getErrMain (state) { return state.errMain },
  getTabs (state) { return state.tabs[role()] }
}
const mutations = {
  setModel (state, data) { state.model = data },
  setId (state, data) { state.id = data },
  setUserId (state, data) { state.userId = data },
  setShow (state, data) { state.show = data },
  setOne (state, data) { state.one = data },
  setAll (state, data) { state.all = data },
  setErrors (state, data) { state.errors[data.param] = data.value },
  setErrMain (state, data) { state.errMain = data },
  setTab (state, data) { state.tabs[role()][data.param].active = data.value },
  setOrder (state, data) {
    for (let param in state.model) {
      if (state.model[param].order && state.model[param].showOrder && state.model[param] != state.model[data.param]) state.model[param].order = null
    };
    let order = state.model[data.param].order
    if (!order) order = 'desc'
    else if (order == 'desc') order = 'asc'
    else if (order == 'asc') order = null
    state.model[data.param].order = order
  }
}
const actions = {
  setActiveTab ({ commit, state }, data) {
    let param = data.param
    let tabs = state.tabs[role()]
    for (let tab in tabs) {
      if (param == tab) commit('setTab', { param: tab, value: true })
      else commit('setTab', { param: tab, value: false })
    };
  },
  setModelRequired ({ commit }, data) {
    commit('setModel', mapper.modelRequired(data.required, getModel()))
  },
  resetAllErr ({ state, commit }) {
    commit('setErrMain', null)
    let errors = state.errors
    if (errors) {
      for (let err in errors) {
        commit('setErrors', { param: err, value: null })
      };
    };
  },
  sendErrMain ({ commit }, data) {
    console.log(data)
    commit('setErrMain', httpService.error(data))
  },
  toUpdate ({ commit }, data) {
    commit('setId', data.id)
    commit('setShow', 'one')
  },
  toAll ({ commit }) {
    commit('setId', null)
    commit('setShow', 'all')
    commit('setOne', getModel())
  },
  async getOne ({ state, commit, dispatch }, data) {
    try {
      dispatch('resetAllErr')
      if (state.id) {
        let result = await httpService.get(apiModule.admin.getOne, { id: state.id })
        commit('setOne', mapper.dataToView(data.required, getModel(), result.data.data))
      };
    } catch (err) {
      dispatch('sendErrMain', err)
    };
  },
  async getAll ({ state, commit, dispatch }, data) {
    try {
      let order = []
      let model = state.model
      for (let param in model) {
        if (model[param].order) order.push(`${model[param].data},${model[param].order}`)
      };
      data.params.order = order
      let result = await httpService.get(apiModule[role()].getAll, data.params)
      commit('setAll', result)
    } catch (err) {
      dispatch('sendErrMain', err)
    };
  },
  async delete ({ state, dispatch }) {
    try {
      await httpService.delete(apiModule.admin.delete, { id: state.id })
      dispatch('toAll')
    } catch (err) {
      dispatch('sendErrMain', err)
    };
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
